import { render } from "./ItemImagesComponent.vue?vue&type=template&id=186e01a2&scoped=true"
import script from "./ItemImagesComponent.vue?vue&type=script&lang=js"
export * from "./ItemImagesComponent.vue?vue&type=script&lang=js"

import "./ItemImagesComponent.vue?vue&type=style&index=0&id=186e01a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186e01a2"]])

export default __exports__